/**
 * Keep-Alive Service
 * Pings the API health endpoint every 5 minutes to keep the backend warm
 * and ensure the PickReminderHostedService continues running.
 * This prevents the API from going into cold sleep during periods of inactivity.
 */

import { getApiUrl } from "./api";

const KEEP_ALIVE_INTERVAL = 5 * 60 * 1000; // 5 minutes in milliseconds
const KEEP_ALIVE_TIMEOUT = 10000;
const HEALTH_ENDPOINT = '/health';

let keepAliveIntervalId = null;

export function startKeepAlive() {
  if (keepAliveIntervalId) {
    console.warn('Keep-alive is already running');
    return;
  }

  console.log('Starting keep-alive service - will ping every 5 minutes');

  // Ping immediately on start
  pingHealth();

  // Then set up recurring pings
  keepAliveIntervalId = setInterval(pingHealth, KEEP_ALIVE_INTERVAL);
}

export function stopKeepAlive() {
  if (keepAliveIntervalId) {
    clearInterval(keepAliveIntervalId);
    keepAliveIntervalId = null;
    console.log('Keep-alive service stopped');
  }
}

async function pingHealth() {
  const controller = new AbortController();
  const timeoutId = window.setTimeout(() => controller.abort(), KEEP_ALIVE_TIMEOUT);

  try {
    const response = await fetch(getApiUrl(HEALTH_ENDPOINT), {
      method: 'GET',
      signal: controller.signal,
      cache: 'no-store',
    });

    if (response.ok) {
      console.debug(`[${new Date().toLocaleTimeString()}] Keep-alive ping successful`);
    } else {
      console.warn(`Keep-alive ping returned status ${response.status}`);
    }
  } catch (error) {
    console.warn('Keep-alive ping failed:', error.message);
    // Don't stop the service on failure - just log it
    // The service will try again in 5 minutes
  } finally {
    window.clearTimeout(timeoutId);
  }
}
